module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-10-4a372369b5d7b611c8789c2fa4dd4bff.svg";